<template>
	<div class="animated fadeIn">
		<div class="row">
			<div class="col">
				<b-button
					v-if="hasAccess('New3PLUser')"
					class="float-right"
					variant="success"
					@click="$router.push({ name: 'New3PLUser'});">
					{{ translate('create') }}
				</b-button>
			</div>
		</div>
		<hr>
		<div class="table-responsive">
			<table class="table table-hover table-striped text-nowrap">
				<thead>
					<tr>
						<th class="border-top-0">
							#
						</th>
						<th
							class="border-top-0">
							{{ translate('user_id') }}
						</th>
						<th
							class="border-top-0">
							{{ translate('username') }}
						</th>
						<th
							class="border-top-0">
							{{ translate('type') }}
						</th>
						<th
							class="border-top-0">
							{{ translate('name') }}
						</th>
						<th
							class="border-top-0">
							{{ translate('email') }}
						</th>
						<th
							class="border-top-0">
							{{ translate('status') }}
						</th>
						<th class="border-top-0 text-center">
							{{ translate('options') }}
						</th>
					</tr>
				</thead>
				<tbody v-if="!loading && hasData">
					<tr
						v-for="(item, index) in data"
						:key="index">
						<td class="align-middle">
							{{ ((pagination.per_page * pagination.current_page) - pagination.per_page) + (index + 1) }}
						</td>
						<td class="align-middle">
							<span class="badge badge-primary">{{ item.id }}</span>
						</td>
						<td class="align-middle">
							{{ item.attributes.username }}
						</td>
						<td class="align-middle">
							{{ translate(item.attributes.type) }}
						</td>
						<td class="align-middle">
							{{ item.attributes.name }}
						</td>
						<td class="align-middle">
							{{ item.attributes.email }}
						</td>
						<td class="align-middle">
							{{ translate(item.attributes.status.toLowerCase()) }}
						</td>
						<td class="text-center align-middle">
							<template
								v-if="showButtons(item)">
								<b-button
									v-if="hasAccess('Update3plUserPassword', { userId3pl: item.id })"
									v-b-tooltip.hover
									:title="translate('update_thing', {name: translate('password')})"
									variant="primary"
									class="bg-primary-alt mr-1"
									@click="$router.push({ name: 'Update3plUserPassword', params: { userId3pl: item.id, username: item.attributes.username } });">
									<i
										class="fa fa-key"
										aria-hidden="true" />
								</b-button>
							</template>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<isLoading
			:loading-label="translate('loading')"
			:no-data-label="translate('data_not_found')"
			:loading="loading"
			:has-data="hasData" />
		<b-pagination
			v-if="pagination.total_pages > 1"
			v-model="pagination.current_page"
			:total-rows="pagination.total"
			:per-page="pagination.per_page"
			align="center"
			@change="getDataFiltered" />
	</div>
</template>
<script>

import { PAGINATION } from '@/settings/RequestReply';
import {
	Countries, Profile, Users, Tooltip, Grids,
} from '@/translations';
import Customer from '@/util/User';

export default {
	name: 'ThirdPartyLogisticsUsers',
	messages: [Countries, Profile, Users, Tooltip, Grids],
	data() {
		return {
			users: new Customer(),
		};
	},
	computed: {
		loading() {
			return !!this.users.data.loading;
		},
		pagination() {
			return this.users.data.pagination;
		},
		data() {
			try {
				const { data } = this.users.data.response.data;
				return data;
			} catch (error) {
				return [];
			}
		},
		hasData() {
			const response = this.data.length;
			return !!response;
		},
	},
	mounted() {
		this.users.get3plUsers();
	},
	methods: {
		getDataFiltered(page) {
			const { query } = this.$route;
			const options = { ...query };
			if (typeof page === 'number') {
				options[PAGINATION] = page;
			}

			this.users.get3plUsers(options);
		},
		showButtons(item) {
			return this.hasAccess('Update3plUserPassword', { userId3pl: item.id });
		},
	},
};
</script>
